export default __webpack_public_path__ + "static/media/habano-1Closed.b24e364b.jpg";